/* ONDA URBANA — theme.js (vanilla, sin dependencias) */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const money = (cents) => {
    const fmt = (window.OU && window.OU.moneyFormat) || '${{amount}}';
    const n = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/{{\s*amount[^}]*}}/, n);
  };

  /* --- apariciones --- */
  const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
  const observar = (root = document) => $$('.reveal:not(.in)', root).forEach((el) => (reduce ? el.classList.add('in') : io.observe(el)));
  observar();
  document.addEventListener('shopify:section:load', (e) => observar(e.target));

  /* --- overlay / paneles --- */
  const overlay = $('#overlay');
  let abierto = null;
  const abrir = (el) => { cerrar(); abierto = el; el.setAttribute('aria-hidden', 'false'); overlay && overlay.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; const f = el.querySelector('input,button,a'); f && setTimeout(() => f.focus(), 350); };
  const cerrar = () => { if (!abierto) return; abierto.setAttribute('aria-hidden', 'true'); abierto = null; overlay && overlay.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
  overlay && overlay.addEventListener('click', cerrar);
  document.addEventListener('keydown', (e) => e.key === 'Escape' && cerrar());
  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-abrir]'); if (t) { e.preventDefault(); const el = $(t.dataset.abrir); el && abrir(el); return; }
    if (e.target.closest('[data-cerrar]')) { e.preventDefault(); cerrar(); }
  });

  /* --- hero parallax suave --- */
  const hero = $('.hero img[data-parallax]');
  if (hero && !reduce) addEventListener('scroll', () => { const y = Math.min(scrollY, 800); hero.style.transform = `scale(1.04) translateY(${y * 0.1}px)`; }, { passive: true });

  /* --- carrito (Ajax) --- */
  const drawer = $('#drawer');
  async function refrescarDrawer(cart) {
    try {
      const r = await fetch(`${window.OU?.rootUrl || '/'}?sections=cart-drawer-items`); const j = await r.json();
      const body = $('#drawer-body'); if (body && j['cart-drawer-items']) body.innerHTML = j['cart-drawer-items'];
    } catch (e) {}
    if (!cart) { try { cart = await (await fetch('/cart.js')).json(); } catch (e) { return; } }
    $$('[data-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    const c = $('#drawer-count'); if (c) c.textContent = `(${cart.item_count})`;
    const t = $('#drawer-total'); if (t) t.textContent = money(cart.total_price);
    const f = $('#drawer-foot'); if (f) f.hidden = cart.item_count === 0;
  }
  async function agregar(form) {
    const btn = form.querySelector('[type=submit]'); const txt = btn && btn.querySelector('span');
    const old = txt && txt.textContent; if (txt) txt.textContent = window.OU?.t?.agregando || 'Agregando…'; if (btn) btn.disabled = true;
    try {
      const fd = new FormData(form);
      const r = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
      if (!r.ok) { const j = await r.json(); throw new Error(j.description || j.message || 'Error'); }
      const cart = await (await fetch('/cart.js')).json();
      await refrescarDrawer(cart);
      if (drawer) abrir(drawer);
    } catch (err) {
      const e = form.querySelector('.form-error') || Object.assign(document.createElement('p'), { className: 'form-error compra__stock compra__stock--no' });
      e.textContent = err.message; form.appendChild(e);
    } finally { if (txt) txt.textContent = old; if (btn) btn.disabled = false; }
  }
  document.addEventListener('submit', (e) => { const f = e.target.closest('form[data-ajax-cart]'); if (f) { e.preventDefault(); agregar(f); } });
  async function cambiar(line, quantity) {
    const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
    const cart = await r.json();
    if ($('.tpl-cart')) location.reload(); else refrescarDrawer(cart);
  }
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-qty]'); if (q) { const inp = q.parentElement.querySelector('input'); const v = Math.max(0, (+inp.value || 0) + (+q.dataset.qty)); inp.value = v; if (inp.dataset.line) cambiar(+inp.dataset.line, v); return; }
    const x = e.target.closest('[data-quitar]'); if (x) { cambiar(+x.dataset.quitar, 0); }
  });
  document.addEventListener('change', (e) => { const inp = e.target.closest('input[data-line]'); if (inp) cambiar(+inp.dataset.line, Math.max(0, +inp.value || 0)); });

  /* --- ficha de producto: variantes --- */
  $$('[data-product-form]').forEach((form) => {
    const datos = JSON.parse(form.querySelector('[data-variants]')?.textContent || '[]');
    const idInput = form.querySelector('input[name="id"]');
    const precio = $('[data-precio]'), compara = $('[data-compara]'), ahorro = $('[data-ahorro]'), stock = $('[data-stock]'), btn = form.querySelector('[type=submit] span'), galeria = $('[data-galeria]');
    const t = window.OU?.t || {};
    function seleccion() { return $$('fieldset', form).map((fs) => fs.querySelector('input:checked')?.value); }
    // muestra solo las fotos del color elegido (alt termina en "color <Color>"); las sin color siempre se ven
    function filtrarGaleria() {
      const c = form.querySelector('fieldset[data-opcion="Color"] input:checked')?.value;
      if (!c) return;
      document.querySelectorAll('.gal').forEach((g) => {
        const items = g.querySelectorAll('.gal__item');
        let visibles = 0;
        items.forEach((it) => {
          const alt = it.querySelector('img')?.getAttribute('alt') || '';
          const m = alt.match(/ color (.+)$/i);
          const oculta = !!m && m[1].trim().toLowerCase() !== c.trim().toLowerCase();
          it.hidden = oculta; if (!oculta) visibles++;
        });
        if (!visibles) items.forEach((it) => { it.hidden = false; });
        // la primera foto visible es la grande (portada)
        items.forEach((it) => it.classList.remove('gal__item--main'));
        const primera = [...items].find((it) => !it.hidden);
        if (primera) primera.classList.add('gal__item--main');
      });
    }
    function actualizar() {
      const sel = seleccion();
      // sin fieldsets (producto de una sola variante) la selección es vacía: usar la única variante
      const v = sel.length ? datos.find((x) => x.options.every((o, i) => o === sel[i])) : datos[0];
      $$('[data-opcion-valor]', form).forEach((el) => { const i = +el.dataset.idx; el.textContent = sel[i] || ''; });
      if (!v) { if (btn) btn.textContent = t.no_disponible || 'No disponible'; return; }
      idInput.value = v.id;
      if (precio) precio.textContent = money(v.price);
      if (compara) { compara.hidden = !(v.compare_at_price > v.price); compara.textContent = v.compare_at_price ? money(v.compare_at_price) : ''; }
      if (ahorro) { const con = v.compare_at_price > v.price; ahorro.hidden = !con; if (con) ahorro.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      const b = form.querySelector('[type=submit]');
      if (v.available) { b.disabled = false; if (btn) btn.textContent = t.agregar || 'Agregar a la bolsa'; if (stock) { stock.textContent = t.en_stock || 'En existencia'; stock.classList.remove('compra__stock--no'); } }
      else { b.disabled = true; if (btn) btn.textContent = t.agotado || 'Agotado'; if (stock) { stock.textContent = t.agotado_msg || 'Agotado por ahora'; stock.classList.add('compra__stock--no'); } }
      filtrarGaleria(sel);
      if (v.featured_media && galeria) { const el = galeria.querySelector(`[data-media-id="${v.featured_media.id}"]`); if (el) { el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest', inline: 'start' }); } }
      const url = new URL(location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      // deshabilitar visualmente combinaciones sin stock (para la última opción)
    }
    form.addEventListener('change', (e) => { if (e.target.matches('input[type=radio]')) actualizar(); });
    actualizar();
  });

  /* --- newsletter: mostrar mensaje si vuelve con éxito --- */
  if (location.hash === '#newsletter' || location.search.includes('customer_posted=true')) { const ok = $('.news .ok'); if (ok) ok.hidden = false; }
})();
